/*
 * Action Types
 */

export const DELETE_COOKIE_FAILURE = "fsci/auth/DELETE_COOKIE_FAILURE";
export const DELETE_COOKIE_REQUEST = "fsci/auth/DELETE_COOKIE_REQUEST";
export const DELETE_COOKIE_SUCCESS = "fsci/auth/DELETE_COOKIE_SUCCESS";
export const READ_COOKIE_FAILURE = "fsci/auth/READ_COOKIE_FAILURE";
export const READ_COOKIE_REQUEST = "fsci/auth/READ_COOKIE_REQUEST";
export const READ_COOKIE_SUCCESS = "fsci/auth/READ_COOKIE_SUCCESS";
export const SAVE_COOKIE_FAILURE = "fsci/auth/SAVE_COOKIE_FAILURE";
export const SAVE_COOKIE_REQUEST = "fsci/auth/SAVE_COOKIE_REQUEST";
export const SAVE_COOKIE_SUCCESS = "fsci/auth/SAVE_COOKIE_SUCCESS";

/*
 * Dispatch Types
 */

export interface DeleteCookieFailure {
    type: typeof DELETE_COOKIE_FAILURE;
}

export interface DeleteCookieRequest {
    type: typeof DELETE_COOKIE_REQUEST;
}

export interface DeleteCookieSuccess {
    type: typeof DELETE_COOKIE_SUCCESS;
}

export interface ReadCookieFailure {
    type: typeof READ_COOKIE_FAILURE;
}

export interface ReadCookieRequest {
    type: typeof READ_COOKIE_REQUEST;
}

export interface ReadCookieSuccess {
    type: typeof READ_COOKIE_SUCCESS;
    payload: Cookie;
}

export interface SaveCookieFailure {
    type: typeof SAVE_COOKIE_FAILURE;
}

export interface SaveCookieRequest {
    type: typeof SAVE_COOKIE_REQUEST;
    payload: Cookie;
}

export interface SaveCookieSuccess {
    type: typeof SAVE_COOKIE_SUCCESS;
    payload: Cookie;
}

export type AuthActionTypes =
    | DeleteCookieFailure
    | DeleteCookieRequest
    | DeleteCookieSuccess
    | ReadCookieFailure
    | ReadCookieRequest
    | ReadCookieSuccess
    | SaveCookieFailure
    | SaveCookieRequest
    | SaveCookieSuccess;

/*
 * Reducer
 */

export type AuthState = Readonly<{
    isAdmin: boolean;
    isLoggedIn: boolean;
}>;

export const INITIAL_STATE: AuthState = {
    isAdmin: false,
    isLoggedIn: false,
};

export default function authReducer(state = INITIAL_STATE, action: AuthActionTypes): AuthState {
    switch (action.type) {
        case DELETE_COOKIE_SUCCESS:
            return INITIAL_STATE;
        case READ_COOKIE_FAILURE:
            return INITIAL_STATE;
        case READ_COOKIE_SUCCESS:
            return { isAdmin: action.payload.isAdmin, isLoggedIn: true };
        case SAVE_COOKIE_FAILURE:
            return INITIAL_STATE;
        case SAVE_COOKIE_SUCCESS:
            return { isAdmin: action.payload.isAdmin, isLoggedIn: true };
        default:
            return state;
    }
}
